import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import ProfileDetailForm from "../../components/UI/Form/ProfileDetailForm";
import { updateProfileDetails } from "../../store/state-slices/profileDetails";
import useApiHttp from "../../hooks/use-http";
//img
// import logo from "../../assets/svg/jiophotos-logo.svg";
import logo from "../../assets/png/JioCloud-Logo.png";

//css
import classes from "./Profile.module.css";
import { Button, Notifications, Text } from "@jds/core";
import { Box, Stack } from "@mui/material";
import JdsModal from "../../components/UI/JdsModal";
import { authActions } from "../../store/state-slices/auth";

const Profile = ({ }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails
  );
  const [logoutConfirmation, setLogoutConfirmation] = useState(true);
  const loginDetails = useSelector(state => state.auth.loginDetails)
  const isJitoUser = loginDetails?.userType === 'JITO'

  const { isLoading: isGettingProfile, sendRequest: getProfile } = useApiHttp();
  const { isLoading: isLogingOut, sendRequest: logoutUser } = useApiHttp();
  useEffect(() => {
    if (
      profileDetailsRedux &&
      Object.keys(profileDetailsRedux).length === 0 &&
      profileDetailsRedux.constructor === Object
    ) {
      navigate("/home");
    }
  }, []);
  return (
    <>
      <header className="header">
        <div className={classes["header__container"]}>
          {/* {
            profileDetailsRedux?.profilePictureThumbnailUrl == null ? (
            <div className={classes["header__logo-box"]}>
              <Stack direction='row' gap={1} alignItems='center'>
                <img src={logo} alt="jio photos logo" style={{ width: '40px' }} />
                <Text text="JioAICloud" appearance="body-m-bold" color="white" />
              </Stack>
            </div>
          ) : 
          (
            <NavLink to={`${process.env.REACT_APP_JIOCLOUD_HOME_URL}`} className={classes["header__logo-box"]}>
              <Stack direction='row' gap={1} alignItems='center'>
                <img src={logo} alt="jio photos logo" style={{ width: '40px' }} />
                <Text text="JioAICloud" appearance="body-m-bold" color="white" />
              </Stack>
            </NavLink>
          )} */}
          {!isJitoUser ?
            <NavLink to={`${process.env.REACT_APP_JIOCLOUD_HOME_URL}`} className={classes["header__logo-box"]}>
              <Stack direction='row' gap={1} alignItems='center'>
                <img src={logo} alt="jio photos logo" style={{ width: '40px' }} />
                <Text text="JioAICloud" appearance="body-m-bold" color="white" />
              </Stack>
            </NavLink>
            :
            <Stack direction='row' gap={1} alignItems='center'>
              <img src={logo} alt="jio photos logo" style={{ width: '40px' }} />
              <Text text="JioAICloud" appearance="body-m-bold" color="white" />
            </Stack>
          }
          {/* <Box sx={{ flexGrow: 1, textAlign: "right" }}>
            <Button
              label="Sign out"
              kind="primary"
              iconLeft={"IcLogin"}
              onClick={() => setLogoutConfirmation(false)}
            />
          </Box> */}
        </div>
      </header>
      <Box
        className="custom-scrollbar"
        sx={{
          height: "calc(100vh - 72px)",
          marginTop: "72px",
          backgroundColor: "var(--color-primary-grey-20)",
          overflow: "auto",
        }}
      >
        <div
          style={{
            maxWidth: "600px",
            margin: "48px auto",
            padding: "32px",
            backgroundColor: "#fff",
            borderRadius: "16px",
            boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
          }}
        >
          <Box mb={3}>
            <Text text="Profile Details" appearance="body-l-bold" />
          </Box>
          <ProfileDetailForm
            updateProfile={() => {
              getProfile(
                {
                  base: "AUTH",
                  url: `profile`,
                  method: "GET",
                },
                null,
                (data) => {
                  dispatch(
                    updateProfileDetails({
                      profileDetails: data?.data,
                    })
                  );
                  navigate("/home");
                }
              );
            }}
          />
        </div>
      </Box>

      <JdsModal
        size="m"
        header="Do you want to sign out?"
        kind="dialog"
        primaryCTA={{
          title: "Yes",
        }}
        secondaryCTA={{
          title: "No",
        }}
        close={logoutConfirmation}
        onClose={() => setLogoutConfirmation(true)}
        onPrimaryClick={() => {
          logoutUser(
            {
              base: "AUTH",
              url: `user/web-logout`,
              method: "POST",
              body: {
                accessToken: localStorage.authToken,
                refreshToken: localStorage.refreshToken,
              },
            },
            null,
            (data) => {
              Notifications.toast.success({
                id: "logout",
                title: data.message,
              });
              dispatch(authActions.setLogout());
              window.location.href = process.env.REACT_APP_JIOCLOUD_HOME_URL;
              // navigate("/auth/signin");
            }
          );
        }}
        onSecondaryClick={() => setLogoutConfirmation(true)}
        primaryCtaDisabled={isLogingOut}
      />
    </>
  );
};

export default Profile;
